// All tuning values live here (GDD numbers marked "tune").

export const AU = 1.495978707e11; // m
export const C_LIGHT = 299_792_458; // m/s
export const DAY = 86_400; // s

export const RENDER = {
  near: 0.25,
  far: 1e15,
  fovChase: 65,
  fovCockpit: 75,
  maxDpr: 2,
  exposure: 1.0,
  bloomStrength: 0.55,
  bloomRadius: 0.4,
  bloomThreshold: 0.85,
};

export const FLIGHT = {
  /** max speed per metre of altitude above the nearest surface (1/s) */
  speedPerAltitude: 0.4,
  minMaxSpeed: 300, // m/s at ground level, full throttle
  capSpeed: 3e10, // ≈ 100 c
  boostMultiplier: 3,
  throttleRate: 0.6, // throttle units per second while W/S held
  reverseLimit: -0.15,
  accelTime: 1.2, // seconds to close ~63% of the gap to target velocity
  strafeSpeed: 120, // m/s up/down with R/F
  mouseSensitivity: 0.0022,
  stickRecenter: 1.6, // virtual stick decay per second when mouse is still
  pitchRate: 0.75, // rad/s at full stick (capital ships turn deliberately)
  yawRate: 0.5,
  rollRate: 1.0,
  angularResponse: 6, // 1/s smoothing of angular velocity
  landingMaxSpeed: 10, // m/s: faster impact = crash
  corotateAltitude: 300_000, // m: below this the ship turns with the planet
};

export const WARP = {
  spoolTime: 2, // s
  speedPerAltitude: 3, // 1/s (normal flight: 0.4)
  cap: 3e11, // ≈ 1,000 c
  massLockDistance: 2_500, // m: rocks/ships closer than this block the drive
  dropoutRadii: 1.5, // drop out when closing on a body inside N radii (Sun: 4)
  turnFactor: 0.5,
  autopilotEngageAbove: 5e7, // m remaining
  autopilotDisengageBelow: 2.5e7,
};

export const CAMERA = {
  followRate: 9, // 1/s exponential smoothing of chase camera position
  rotateRate: 7,
  chaseDistance: 2.1, // × ship length
  chaseHeight: 0.42,
  boostFovKick: 8,
};

export const SPAWN = {
  bodyId: 'earth',
  altitude: 400_000, // m (LEO)
  latDeg: 0,
  lonDeg: -60,
};

export const TEXTURES = {
  hiResWithinRadii: 40, // load 8K tier when closer than N body radii
  unloadBeyondRadii: 120,
};

export const COMBAT = {
  laserRange: 6_000,
  laserCooldown: 0.14,
  aimAssistDeg: 4,
  shieldBase: 60,
  shieldPerStat: 90, // + spec.shield × this
  rockHitDamage: 35, // at 40 m/s relative speed; scales with impact
  shieldRegen: 5, // per second
  regenDelay: 5, // seconds after damage
  respawnDelay: 3,
  traumaDecay: 1.3,
};
